import React from "react";
import {
  Datagrid,
  List,
  SimpleShowLayout,
  TextField,
  DateField,
  Filter,
  TextInput,
  required, ReferenceField, ReferenceInput, SelectInput,
} from "react-admin";
import ShowView from "../../components/ShowView";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";


const UserVariantFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="آزمایش " validate={required()} source="experimentId" reference="experiment">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <ReferenceInput label="کاربر " validate={required()} source="userId" reference="user">
      <SelectInput optionText="name" alwaysOn/>
    </ReferenceInput>
  </Filter>
);

export const UserVariantList = (props) => (
  <List {...props} filters={<UserVariantFilter/>} perPage={10}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <ReferenceField link="show" label="آزمایش" source="experimentId" reference="experiment">
        <TextField source="title"/>
      </ReferenceField>
      <ReferenceField link="show" label="متغییر" source="variantId" reference="variant">
        <TextField source="title"/>
      </ReferenceField>
      <ReferenceField link="show" label="کاربر" source="userId" reference="user">
        <TextField source="name"/>
      </ReferenceField>
      <TextField label={"شناسه کاربر ثبت نام نشده"} source="uuId"/>

    </Datagrid>
  </List>
);

export const UserVariantShow = (props) => (
  <ShowView {...props} noEdit={false}>
    <SimpleShowLayout>
      <TextField label="شناسه" source="objectId"/>

      <ReferenceField link="show" label="آزمایش" source="experimentId" reference="experiment">
        <TextField source="title"/>
      </ReferenceField>

      <ReferenceField link="show" label="متغییر" source="variantId" reference="variant">
        <TextField source="title"/>
      </ReferenceField>

      <ReferenceField link="show" label="کاربر" source="userId" reference="user">
        <TextField source="name"/>
      </ReferenceField>

      <TextField label={"شناسه کاربر ثبت نام نشده"} source="uuId"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>

    </SimpleShowLayout>
  </ShowView>
);

export const UserVariantEdit = (props) => (
  <EditView {...props}>
    <TextField source="objectId"/>
    <ReferenceInput label="آزمایش " validate={required()} source="experimentId" reference="experiment">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <ReferenceInput label="متغییر " validate={required()} source="variantId" reference="variant">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>

    <ReferenceField link="show" label="کاربر" source="userId" reference="user">
      <TextField source="name"/>
    </ReferenceField>
    <TextField label={"شناسه کاربر ثبت نام نشده"}
               source="uuId"/>

  </EditView>
);

export const UserVariantCreate = (props) => (
  <CreateView {...props}>
    <ReferenceInput label="آزمایش " validate={required()} source="experimentId" reference="experiment">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <ReferenceInput label="متغییر " validate={required()} source="variantId" reference="variant">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>

    <TextInput source={'userId'} label={"شناسه کاربر"}/>
    <TextInput source={'uuId'} label={"شناسه کاربر ثبت نام نشده"}/>

  </CreateView>
);
